<template>
	<div class="template_box template_box_UserInfo">
		<div class="template">
			<div class="header">
				<goBack :page_title="page_title"></goBack>
			</div>
			<el-form ref="form_base" :model="user" :rules="rules" label-position="left" label-width="180px">
				<!-- <div class="itemBox">
					<div class="label" for="avatar">Head shot:</div>
					<div class="textBox avatarBox">
						<ImgUploadUserInfo ref="PicsUpload" :FileList="AvatarList" :uploadType="uploadTypeAvatar" :maxFileList="maxImgList" :acceptType="acceptType" @remove_imgs_Avatar='remove_imgs_Avatar' @save_imgs_Avatar='save_imgs_Avatar'></ImgUploadUserInfo>
					</div>
				</div> -->
				
				<el-form-item label="Head shot:" prop="avatar" class="itemBox avatarItemBox">
					<div class="avatarBox">
						<ImgUploadUserInfo ref="PicsUpload" :FileList="AvatarList" :uploadType="uploadTypeAvatar" :maxFileList="maxImgList" :acceptType="acceptType" @remove_imgs_Avatar='remove_imgs_Avatar' @save_imgs_Avatar='save_imgs_Avatar'></ImgUploadUserInfo>
					</div>
				</el-form-item>
				
				<el-form-item label="Nickname:" prop="nickname" class="itemBox">
					<el-input v-model="user.nickname" :maxlength="50" :disabled="editable" :placeholder="placeholder.nickname" type="text" />
				</el-form-item>
				
				<el-form-item label="Countries or Regions:" prop="country" class="itemBox">
					<el-select v-model="user.country" :placeholder="placeholder.country">
					  <el-option v-for="(item, index) in countryList" :key="item.id" :label="item.name" :value="item.iso_code" ></el-option>
					</el-select>
				</el-form-item>
				
				<!-- <el-form-item label="Countries or Regions:" class="itemBox">
					<div class="BirthdayItemBox">
						<el-form-item prop="address" label-width="0px">
							<el-select v-model="user.address" placeholder="Please select year"  @change="onProvinceChange()">
							  <el-option v-for="(item, index) in provinceList" :key="index" :label="item.name" :value="item.iso_code" ></el-option>
							</el-select>
						</el-form-item>
						<el-form-item prop="city" label-width="0px" @change="onCityChange()">
							<el-select v-model="user.city" placeholder="Please select month">
							  <el-option v-for="(item, index) in cities" :key="index" :label="item.name" :value="item.iso_code" ></el-option>
							</el-select>
						</el-form-item>
						<el-form-item prop="area" label-width="0px">
							<el-select v-model="user.area" placeholder="Please select date">
							  <el-option v-for="(item, index) in areas" :key="index" label="item.name" :value="item.iso_code" ></el-option>
							</el-select>
						</el-form-item>
					</div>
				</el-form-item> -->
				
				<!-- <el-form-item label="Address:" prop="address" class="itemBox">
					<el-input v-model="user.address":maxlength="200" :disabled="editable" placeholder="Please enter the detailed address" type="text" />
				</el-form-item> -->
				
				<el-form-item label="Gender:" prop="gender" class="itemBox">
					<el-select v-model="user.gender" :placeholder="placeholder.gender">
					  <el-option v-for="(item, index) in genderList" :key="index" :label="item.name" :value="item.value" ></el-option>
					</el-select>
				</el-form-item>
				
				
				<el-form-item label="Birthday:" prop="birthday" class="itemBox">
					<div class="BirthdayItemBox">
						<el-form-item prop="birthdayYear" label-width="0px">
							<el-select v-model="user.birthdayYear" :placeholder="placeholder.year">
							  <el-option v-for="(item, index) in years" :key="item" :label="item" :value="item" ></el-option>
							</el-select>
						</el-form-item>
						<el-form-item prop="birthdayMonth" label-width="0px">
							<el-select v-model="user.birthdayMonth" :placeholder="placeholder.month">
							  <el-option v-for="(item, index) in months" :key="item" :label="item" :value="item" ></el-option>
							</el-select>
						</el-form-item>
						<el-form-item prop="birthdayDay" label-width="0px">
							<el-select v-model="user.birthdayDay" :placeholder="placeholder.date">
							  <el-option v-for="(item, index) in days" :key="item" :label="item" :value="item" ></el-option>
							</el-select>
						</el-form-item>
					</div>
				</el-form-item>
				
				<el-form-item label="Background:" prop="bg_img" class="itemBox BackgroundItemBox">
					<div class="bg_img_box" @click.stop="background_fun()">
						<ImgUploadUserInfo ref="PicsUpload" :FileList="BackgroundList" :uploadType="uploadTypeBackground" :maxFileList="maxImgList" :acceptType="acceptType" @remove_imgs_Background='remove_imgs_Background' @save_imgs_Background='save_imgs_Background'></ImgUploadUserInfo>
					</div>
				</el-form-item>
			
			</el-form>
			<div class="itemBox post_btn_box">
				<button type="button" class="post_btn" :class="isSubmitting ? 'no_drop' : 'pointer'" :disabled="isSubmitting" @click="submitForm" >
					{{ isSubmitting ? $t('buttonArr.Save') : $t('buttonArr.Save') }}
				</button>
			</div>
			
		</div>
		
		<div class="LoadingBox" v-if="Loading">
			<Loading :LoadingText="LoadingText"></Loading>
		</div>
	</div>
</template>

<script>
import { post_community_edituserinfo, post_community_userinfo } from '@/api/community.js'
import { getCountry } from '@/api/country.js'
import { rules } from "./js/EditInformationCustom.js"

import ImgUploadUserInfo from "../../components/FileUpload/ImgUploadUserInfo.vue";

const today = new Date();
const year = today.getFullYear();
const month = (today.getMonth() + 1).toString().padStart(2, '0');
const day = today.getDate().toString().padStart(2, '0');
export default {
	name: 'edit-personal-information',
	components: { ImgUploadUserInfo },
	data() {
    return {
		page_title: this.$t('EditPersonalInformation.page_title'),
      user: {
			avatar: '',
			nickname: '',
			country: '',
			province: '',
			city: '',
			area: '',
			address: '',
			gender: '',
			birthday: `${year}-${month}-${day}`,
			birthdayYear: year,
			birthdayMonth: month,
			birthdayDay: day,
			bg_img: ''
      },
		rules: rules,
		placeholder:{
			nickname: this.$t('EditPersonalInformation.placeholder.nickname'),
			country: this.$t('EditPersonalInformation.placeholder.country'),
			gender: this.$t('EditPersonalInformation.placeholder.gender'),
			year: this.$t('EditPersonalInformation.placeholder.year'),
			month: this.$t('EditPersonalInformation.placeholder.month'),
			date: this.$t('EditPersonalInformation.placeholder.date'),
		},
		copyUser:{},
		countryList: [],
      provinceList: [], // 示例省份列表，实际开发可从接口获取
      cities: [],
      areas: [],
      years: [],
      months: [],
      days: [],
		isSubmitting: true,
		Loading: false,
		LoadingText: false,
		genderList:[
			{value: 1, name: this.$t('EditPersonalInformation.genderList.male')},
			{value: 2, name: this.$t('EditPersonalInformation.genderList.female')},
			{value: 0, name: this.$t('EditPersonalInformation.genderList.other')}
		],
		AvatarList: [],
		BackgroundList: [],
		acceptType:"image/jpeg, image/png, image/webp, image/jpg",
		maxImgList: 1,
		uploadTypeAvatar: 1,//1头像  2背景
		uploadTypeBackground: 2,//1头像  2背景
		editable: false,
		flag: false,
    };
	},
	
	watch: {
		"user": {
			handler: function (val, oldval) {
				this.get_empty()
				this.Is_there_any_change()
			},
			deep: true,
		},
		"user.birthdayYear": {
			handler: function (val, oldval) {
				this.created_months_list()
				this.created_days_list()
			},
			deep: true,
		},
		"user.birthdayMonth": {
			handler: function (val, oldval) {
				this.created_days_list()
			},
			deep: true,
		},
		"$store.state.userinfo": {
			handler: function (val, oldval) {
				this.set_user_data()
			},
			deep: true,
		},
	},
		
	beforeCreate() {
		// const vm = this
	},	

	created() {
		this.created_yeas_list()
		this.created_months_list()
		this.created_days_list()
	},

	beforeDestroy() {
	
	},
	
	
	beforeRouteUpdate(to, from, next) {
		// 当路由更新时，更新 userId 数据
		this.getInfo()
		next();
	},
		
	mounted() {
		this.getCountry()
		this.set_user_data()
		this.get_empty()
	},
	
	methods: {
		set_user_data(){
			console.log(this.$store.state.userinfo)
			let userinfo = this.$store.state.userinfo
			this.user.avatar = userinfo.avatar
			this.user.nickname = userinfo.nickname
			this.user.bg_img = userinfo.bg_img
			this.user.birthday = userinfo.birthday
			this.user.country = userinfo.country
			this.user.gender = userinfo.gender
			
			// userinfo.birthday = '2024-10-10';
			if(userinfo.birthday && userinfo.birthday != ''){
				let [year, month, day] = userinfo.birthday.split('-');
				this.user.birthdayYear = parseInt(year)
				this.user.birthdayMonth = parseInt(month)
				this.user.birthdayDay = parseInt(day)
			}
			
			if(userinfo.avatar && userinfo.avatar != ''){
				this.AvatarList = []
				this.AvatarList.push({url: userinfo.avatar})
			}
			if(userinfo.bg_img && userinfo.bg_img != ''){
				this.BackgroundList = []
				this.BackgroundList.push({url: userinfo.bg_img})
			}
			this.copyUser = JSON.parse(JSON.stringify(this.user));
			console.log(this.copyUser)
			this.created_months_list()
			this.created_days_list()
		},
		
		Is_there_any_change() {
			const keys = ['nickname', 'avatar', 'bg_img'];
			for (let key of keys) {
			  if (this.user[key]!== this.copyUser[key]) {
				 console.log('不相同');
				 // 更新 copyUser 为最新的 user 值
				 this.copyUser = JSON.parse(JSON.stringify(this.user));
				 return;
			  }
			}
		},
		
		Is_there_any_change() {
			// 检查 nickname、avatar、bg_img 是否为空
			const {  avatar, nickname,bg_img } = this.user;
			if (
				typeof avatar ==='string' && avatar.trim() === '' ||
				typeof nickname ==='string' && nickname.trim() === '' ||
				typeof bg_img ==='string' && bg_img.trim() === ''
			){
				console.log('为空');
				return this.isSubmitting = true
			}else{
				// 检查 user 和 copyUser 的所有属性是否相同
				for (const key in this.user) {
				  if (this.user.hasOwnProperty(key)) {
					 if (this.user[key]!== this.copyUser[key]) {
						console.log('不相同');
						return this.isSubmitting = false
					 }
				  }
				}
				return this.isSubmitting = true
				console.log('相同');
			}
			
		},
		
		background_fun(){
			// this.$refs.PicsUpload.triggerPicsUpload();
		},
		
		// 子组件传值
		// 头像保存的图片
		save_imgs_Avatar(obj) {
		  console.log(obj)
			this.AvatarList.push(obj)
			this.user.avatar = obj.url
			this.file_url_validate("avatar")
		  // this.post_data.pics.push(url)
		  // this.imgList.push({ url: url })
		  // this.file_url_validate('imgs')
		},
		
		// 头像删除的图片
		remove_imgs_Avatar(url) {
		  console.log(url)
			this.AvatarList = this.AvatarList.filter((item) => {
				return item.url!== url;
			});
			this.user.avatar = ''
			this.file_url_validate("avatar")
			console.log(this.AvatarList)
			// this.post_data.pics = data
			// this.file_url_validate('imgs')
		},
		
		// 子组件传值
		// 背景保存的图片
		save_imgs_Background(obj) {
		  console.log(obj)
			this.BackgroundList.push(obj)
			this.user.bg_img = obj.url
			this.file_url_validate("bg_img")
		  // this.post_data.pics.push(url)
		  // this.imgList.push({ url: url })
		  // this.file_url_validate('imgs')
		},
		
		// 背景删除的图片
		remove_imgs_Background(url) {
		  console.log(url)
			this.BackgroundList = this.BackgroundList.filter((item) => {
				return item.url!== url;
			});
			this.user.bg_img = ''
			this.file_url_validate("bg_img")
		  console.log(this.BackgroundList)
		  // this.post_data.pics = data
		  // this.file_url_validate('imgs')
		},
		
		get_empty(){
			this.user.birthday = `${this.user.birthdayYear}-${this.user.birthdayMonth}-${this.user.birthdayDay}`
			
			// 使用Object.values获取user对象的所有属性值
			// 假设 this.user 是一个对象
			let isEmpty = Object.entries(this.user).every(([key, val]) => {
				if (typeof val ==='string') {
					return val.trim()!== '';
				} else if (Array.isArray(val)) {
					return val.length!== 0;
				} else if (typeof val === 'object' && val!== null) {
					return Object.keys(val).length!== 0;
				} else {
					// 对于其他数据类型，根据需要进行判断，这里暂时认为不为空
					return false;
				}
			});

			// 检查 avatar、nickname 和 bg_img 是否都不为空
			if (
				typeof this.user.avatar ==='string' && this.user.avatar.trim()!== '' &&
				typeof this.user.nickname ==='string' && this.user.nickname.trim()!== '' &&
				typeof this.user.bg_img ==='string' && this.user.bg_img.trim()!== ''
			) {
				isEmpty = true
			}else{
				isEmpty = false
			}
			if (isEmpty) {
			    this.isSubmitting = false;
			} else {
			    this.isSubmitting = true;
			}
		},
		
		//单个必填验证
		file_url_validate(name) {
        this.$refs.form_base.validateField(name, (val) => {
          if (!val) {
            return true
          } else {
            return false
          }
        })
      },
		
		// 提交内容
		submitForm() {
			this.$refs.form_base.validate((valid) => {
				console.log(valid)
				if (valid) {
					this.flag = true
					return
				} else {
					this.flag = false
					return
				}
			})
			if(!this.flag){
			  this.$message(this.$t('tipsArr.user_info_required_fields'), "error")
			  return
			}
			this.post_community_edituserinfo()
		},
		
		//获取国家信息
		getCountry(){
			getCountry()
		   .then((res) => {
				console.log(res)
				if(res.code == 0){
					this.countryList = res.data
				}else{
					this.exception_handling(res, "getCountry")
				}
		   })
		   .catch((err) => {
				console.log(err)
				this.exception_handling(err, "getCountry")
		   })
		},
		
		//修改信息
		post_community_edituserinfo(){
			if(this.Loading){ return }
			this.isSubmitting = true;
			this.Loading = true
			let data = this.user
			let obj = {
				avatar: data.avatar,
				nickname: data.nickname,
				country: data.country,
				gender: data.gender,
				birthday: data.birthday, 
				bg_img: data.bg_img,
			}
			
			post_community_edituserinfo(obj)
		   .then((res) => {
				console.log(res)
				if(res.code == 0){
					this.getInfo()
					this.successfully(res)
				}else{
					this.exception_handling(res, "edituserinfo")
				}
		   })
		   .catch((err) => {
				console.log(err)
				this.exception_handling(err, "edituserinfo")
		   })
		},
		
		
		//获取用户信息
		getInfo(){
			post_community_userinfo()
		   .then((res) => {
				console.log(res)
				if(res.code == 0){
					let response = res.data
					response.login_way = 'local'
					response.login_token = this.$store.state.userinfo.login_token
					this.$cookie.set('user', JSON.stringify(response), { expires: '7D' })
					this.$store.dispatch('userinfo', [response, this])
					this.$store.commit('changeUserinfo', Object.assign({}, this.$store.state.userinfo, response))
					this.set_user_data()
					this.goBackOrToHome()
				}else{
					this.exception_handling(res)
				}
		   })
		   .catch((err) => {
				console.log(err)
				this.exception_handling(err)
		   })
		},
		
		//成功处理
		successfully(res){
			this.Loading = false
			this.$message(this.$t('tipsArr.Edited_success'), 'success')
			let that = this
			setTimeout(()=>{
				that.isSubmitting = false;
				// that.goBackOrToHome()
				// that.$emit("operations", 'success')
				// that.reset_data()
			}, 1000)
		},
		
		
		//异常处理
		exception_handling(err){
			this.Loading = false
			this.isSubmitting = false;
			this.$errorMessage(err)
			// this.$message('err.data.message', 'error')
		},
		
		// 如果存在上一页，调用方法跳转
		goBackOrToHome() {
		   this.$router.push({ name: 'user-profile' });
		},
		
		created_yeas_list() {
			const currentYear = new Date().getFullYear();
			// 生成年份列表
			for (let i = currentYear; i >= 1900; i--) {
			  this.years.push(i);
			}
		},
		
		created_months_list() {
			const currentDate = new Date();
			const currentYear = currentDate.getFullYear();
			const currentMonth = currentDate.getMonth() + 1;
			
			// 生成月份列表
			this.months = [];
			let max = this.user.birthdayYear === currentYear ? currentMonth : 12;
			for (let i = 1; i <= max; i++) {
			   this.months.push(i);
			}
		},
		
		 // 判断是否为闰年
		 isLeapYear(year) {
			return (year % 4 === 0 && year % 100!== 0) || (year % 400 === 0);
		 },
		 
		 // 获取指定年份和月份的天数
		 getDaysInMonth(year, month) {
			const currentDate = new Date();
			const currentYear = currentDate.getFullYear();
			const currentMonth = currentDate.getMonth() + 1;
			const currentDay = currentDate.getDate();
			
			if(this.user.birthdayYear === currentYear && this.user.birthdayMonth === currentMonth){
				return currentDay
			}else if(this.user.birthdayYear === currentYear && this.user.birthdayMonth > currentMonth){
				return 0;
			}else{
				if ([1, 3, 5, 7, 8, 10, 12].includes(month)) {
				  return 31;
				} else if ([4, 6, 9, 11].includes(month)) {
				  return 30;
				} else if (month === 2) {
				  return this.isLeapYear(year)? 29 : 28;
				}
				return 0;
			}
		 },
		 
		// 更新天数列表
		created_days_list() {
			const daysInMonth = this.getDaysInMonth(this.user.birthdayYear, this.user.birthdayMonth);
			this.days = [];
			for (let i = 1; i <= daysInMonth; i++) {
			  this.days.push(i);
			}
		},
		
		// created_date() {
		// 	const currentYear = new Date().getFullYear();
		// 	for (let i = currentYear; i >= 1900; i--) {
		// 		this.years.push(i);
		// 	}
		// 	for (let i = 1; i <= 12; i++) {
		// 		this.months.push(i);
		// 	}
		// 	for (let i = 1; i <= 31; i++) {
		// 		this.days.push(i);
		// 	}
		// },
		
		onCountryChange() {
			console.log()
			const selectedCountry = this.countryList.find(item => item.iso_code === this.user.country);
			console.log('Selected country:', selectedCountry);
			
			// 国家发生变化时，根据省份更新城市列表，可调用接口获取对应城市数据
			this.provinceList = selectedCountry.states ? selectedCountry.states : []; // 示例城市列表，实际开发可从接口获取
			this.cities = [] // 清空省/州列表
			// this.areas = []; // 清空地区列表
			// this.user.city = '';
			// this.user.area = '';
		},
		onProvinceChange() {
			const selectedProvince = this.provinceList.find(item => item.iso_code === this.user.province);
			console.log('Selected selectedProvince:', selectedProvince);
			
			// 当省份发生变化时，根据省份更新城市列表，可调用接口获取对应城市数据
			this.cities = selectedCountry.cities ? selectedProvince.cities : []; // 示例城市列表，实际开发可从接口获取
			// this.areas = []; // 清空地区列表
			// this.user.city = '';
			// this.user.area = '';
		},
		 
		// onCityChange() {
		// 	// 当城市发生变化时，根据城市更新地区列表，可调用接口获取对应地区数据
		// 	this.areas = ['示例地区1', '示例地区2']; // 示例地区列表，实际开发可从接口获取
		// 	this.user.area = '';
		// }
	}
};
</script>

<style lang="less" scoped>
	.template_box_UserInfo{
		padding: 15px 15px;
		height: 100%;
		background-color: #ffffff;
		border-radius: 8px;
		overflow: hidden;
	}
	.template_box_UserInfo{
		.header{
			font-weight: 400;
			font-size: 20px;
			color: #111111;
			line-height: 1.3;
			text-align: left;
			font-style: normal;
			text-transform: none;
			margin-bottom: 40px;
		}
		.itemBox{
			display: flex;
		}
		.BirthdayItemBox{
			display: flex;
			.el-form-item{
				width: 100%;
				margin-right: 10px;
				&:last-child{
					margin-right: 0px;
				}
			}
			.el-select{
				width: 100%;
			}
		}
		::v-deep .itemBox .el-select{
			width: 100%;
		}
		::v-deep .itemBox>.el-form-item__content{
			height: 37px;
			line-height: 1;
			position: relative;
			font-size: 14px;
			margin-left: 0px !important;
		}
		.bg_img_box{
			height: 177px;
			border-radius: 4px 4px 4px 4px;
			/* border: 1px solid #CFDADE; */
			display: flex;
			justify-content: center;
			align-items: center;
		}
		.post_btn_box{
			margin-top: 30px;
			display: flex;
			justify-content: center;
			.post_btn {
				height: 37px;
				width: 100%;
				max-width: 300px;
				display: flex;
				justify-content: center;
				align-items: center;
				min-width: 100px;
				background: #06f;
				// background-color: #2094FA;
				border-radius: 999px 999px 999px 999px;
				font-weight: 400;
				font-size: 12px;
				color: #FFFFFF;
				line-height: 14px;
				text-align: center;
				font-style: normal;
				text-transform: none;
				border: 0;
			}
				button:disabled{
					background-color: #999999;
				}
		}
		.pointer{
			cursor: pointer;
		}
		.no_drop{
			cursor: no-drop;
		}
	  .LoadingBox{
		  position: fixed;
		  top: 0;
		  left: 0;
		  width: 100%;
		  height: 100%;
		  z-index: 999;
		  display: flex;
		  justify-content: center;
		  align-items: center;
		  background-color: rgba(0,0 0, 0.5);
	  }
	  @media only screen and (min-width: 800px) {
		.el-form-item {
			/* flex-direction: column; */
		}
		
		.itemBox{
			margin-bottom: 28px !important;
		}
		::v-deep .itemBox>.el-form-item__content{
			width: calc(100% - 180px);
			margin-left: 0px !important;
			height: 37px;
			line-height: 1;
			position: relative;
			font-size: 14px;
		}
		
		.avatarItemBox,
		::v-deep .avatarItemBox .el-form-item__content{
			height: 58px !important;
		}
		.BackgroundItemBox,
		::v-deep .BackgroundItemBox .el-form-item__content{
			height: 175px !important;
		}
	  }
	  @media only screen and (max-width: 800px) {
		.el-form-item {
			flex-direction: column;
		}
		.itemBox{
			margin-bottom: 18px !important;
		}
		::v-deep .itemBox>.el-form-item__content{
			width: calc(100% - 0px);
			margin-left: 0px !important;
			line-height: 1;
			position: relative;
			font-size: 14px;
		}
		::v-deep .el-form-item__label{
			width: calc(100% - 0px) !important;
		}
		::v-deep .el-form-item__content{
			width: calc(100% - 0px);
		}
		.avatarItemBox,
		::v-deep .avatarItemBox .el-form-item__content{
			height: 98px !important;
		}
		.BackgroundItemBox,
		::v-deep .BackgroundItemBox .el-form-item__content{
			height: 215px !important;
		}
	}
}
</style>